import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import Historia from "@/pages/Historia";
import Herramientas from "@/pages/Herramientas";
import Precalificacion from "@/pages/Precalificacion";
import Contacto from "@/pages/Contacto";
import CategoryPage from "@/pages/CategoryPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/historia" element={<Historia />} />
          <Route path="/herramientas" element={<Herramientas />} />
          <Route path="/precalificacion" element={<Precalificacion />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/proteger/:slug" element={<CategoryPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
